import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateMobileSettingsRequest,
  UpdateField,
  FetchMobileSettingsRequest,
} from './mobile-settings.actions'
import { getFormsState } from '../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getMobileSettingsState } from './mobile-settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'
import { FetchActiveLayersRequest } from '@shared/shared.actions'
import { getActiveLayers } from '@shared/shared.select'

@Component({
  selector: 'app-mobile-settings',
  templateUrl: './mobile-settings.component.html',
  styleUrls: ['./mobile-settings.component.css'],
})
export class MobileSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean
  public activeLayersState$: Subscription
  public activeLayers: any[] = []

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getMobileSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.activeLayersState$ = this.store
      .pipe(select(getActiveLayers))
      .subscribe((state) => {
        if (this.activeLayers.length === 0) {
          this.activeLayers = state.toJS()
        }
      })

    this.store.dispatch(new FetchMobileSettingsRequest())
    this.store.dispatch<any>(
      new FetchActiveLayersRequest({
        filters: {
          matchOr: [{ field: 'delivery', value: true }],
        },
      }),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
    this.activeLayersState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target?.name,
        name ? e : e.target?.value,
        'data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      SETTINGS_MOBILE_RESPONSIBILITY_LAYER: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      SETTINGS_MOBILE_RESPONSIBILITY_LAYER: 'layer',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const { ...payload } = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateMobileSettingsRequest({
          ...payload,
        }),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
